export default function HeaderPublicLayout() {

  return {
    view: function ({ attrs: { displayLogin = true } }) {
      return [
        m('header.header.header-public.justify-content-between.ps-4.pe-4',
          m('.nav_logo',
            m('.title', 'Samsung MCS'),
          ),
          displayLogin && m('ul.navbar-nav',
            [
              m('li.nav-item.dropdown',
                m('a.nav-link[href="javascript:void(0);"]', { onclick: () => m.route.set("/") }, 'Login'),
              )
            ]
          ),
        )
      ];
    },
  };
}